module.exports = __webpack_public_path__ + "static/img/top02.9025f75f.svg";